import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { getAdminPin } from "../../lib/admin";
import { fetchMe } from "../../lib/auth";
import { apiRaw } from "../../lib/api";

/**
 * RequireAdmin — accepts EITHER a stored tenant PIN OR a valid Google session
 * that owns this tenant.
 */
const RequireAdmin = ({ children }) => {
    const { slug } = useParams();
    const location = useLocation();
    const [state, setState] = useState(() =>
        getAdminPin(slug) ? "ok" : "checking"
    );

    useEffect(() => {
        if (state === "ok") return;
        let cancelled = false;
        (async () => {
            const me = await fetchMe();
            if (cancelled) return;
            if (!me) {
                setState("no");
                return;
            }
            try {
                const r = await apiRaw.get("/auth/my-tenants", { withCredentials: true });
                const owned = (r.data.tenants || []).some((t) => t.slug === slug);
                setState(owned ? "ok" : "no");
            } catch {
                setState("no");
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [slug, state]);

    if (state === "checking") {
        return (
            <div className="min-h-screen bg-[#F9F6F0] flex items-center justify-center text-[#8C7A72]">
                Checking access…
            </div>
        );
    }
    if (state === "no") {
        return <Navigate to={`/${slug}/admin`} replace state={{ from: location.pathname }} />;
    }
    return children;
};

export default RequireAdmin;
